module.exports = __webpack_public_path__ + "img/hrosenau.a78f554c.jpg";